import React from "react";

export const FsmTermsAndConditionsPage: React.FC = () => {
  const email = "infofsm@libero.it";
  const platformName = "fsm_website";

  return (
    <div className="min-h-screen flex justify-center">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-3xl w-full">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Termini e Condizioni d'Uso
        </h1>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Oggetto</h2>
          <p>
            I presenti Termini e Condizioni regolano l'uso della piattaforma{" "}
            <strong>{platformName}</strong>, che consente agli utenti registrati
            di partecipare a tornei, consultare classifiche e interagire con altri
            membri.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Registrazione e Account</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>L'utente deve fornire dati corretti e aggiornati al momento della registrazione.</li>
            <li>L'utente e responsabile della sicurezza delle proprie credenziali.</li>
            <li>Il titolare si riserva il diritto di sospendere o chiudere account in caso di uso improprio.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Utilizzo della piattaforma</h2>
          <p>
            L'utente si impegna a non utilizzare la piattaforma per scopi illeciti,
            offensivi o lesivi di altri utenti. E vietata qualsiasi forma di
            manipolazione delle classifiche o dei tornei.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Responsabilita</h2>
          <p>
            La piattaforma e fornita "cosi com'e". Il titolare non e responsabile di
            eventuali interruzioni, perdite di dati o malfunzionamenti derivanti da
            cause esterne al proprio controllo.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Proprieta intellettuale</h2>
          <p>
            Tutti i contenuti presenti sulla piattaforma (testi, loghi, design,
            codice) sono protetti da copyright e non possono essere copiati,
            distribuiti o utilizzati senza autorizzazione.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Modifiche ai Termini</h2>
          <p>
            Il titolare si riserva il diritto di modificare i presenti Termini in
            qualsiasi momento. Le modifiche avranno effetto dalla loro pubblicazione
            su questa pagina.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">7. Contatti</h2>
          <p>
            Per qualsiasi domanda riguardante i presenti Termini, l'utente puo
            contattare il titolare all'indirizzo <strong>{email}</strong>.
          </p>
        </section>
      </div>
    </div>
  );
};
